import DeviceElevatorIntegrationSettings from './DeviceElevatorIntegrationSettings';

export default DeviceElevatorIntegrationSettings;
